import React from 'react';
export function Guarantee() {
  return <section className="py-10 px-4 bg-brand-dark border-y border-white/5" data-id="element-61">
      <div className="max-w-xl mx-auto text-center" data-id="element-62">
        <h2 className="text-xl font-black mb-4 text-brand-accent" data-id="element-63">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="text-sm text-gray-300 leading-relaxed mb-4" data-id="element-64">
          Abres los tomos. Los usas en el aula. Si en 7 días no es lo que
          esperabas, te devolvemos el 100% de tu dinero.
        </p>
        <p className="text-xs font-bold text-white bg-brand-card inline-block px-3 py-1 rounded-md" data-id="element-65">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </section>;
}